import { inject, Injectable } from '@angular/core';
import { IReportExportStatusDto } from '@core/interfaces/api/reports/reports-export-status-dto.interface';
import { catchError, map, Observable, of, Subject } from 'rxjs';
import { ReportDownloadUseCaseService } from 'src/app/modules/reports/use-cases/report-download.use-case.service';
import { ReportStatusType } from '@core/enums/reports/report-export-status.type';
import { REPORT_STATUS_TYPE } from '@core/const/report-status-type.const';

@Injectable({ providedIn: 'root' })
export class MessageReportService {
  private readonly reportNotification = new Subject<IReportExportStatusDto>();
  reportNotification$ = this.reportNotification.asObservable();
  private readonly reportDownloadUseCaseService = inject(ReportDownloadUseCaseService);

  addNotification(notification: IReportExportStatusDto): void {
    this.reportNotification.next(notification);
  }

  processMessage(
    notification: IReportExportStatusDto,
    id: string
  ): Observable<ReportStatusType | undefined> {
    const { jobId, status } = notification;

    if (jobId !== id) {
      return of(undefined);
    }

    switch (status.toLowerCase()) {
      case REPORT_STATUS_TYPE.GENERATED: {
        const { fileUrl } = notification;
        return this.downloadReport(fileUrl);
      }
      case REPORT_STATUS_TYPE.GENERATING:
        return of(REPORT_STATUS_TYPE.GENERATING);
      case REPORT_STATUS_TYPE.ERROR:
        throw new Error('Failed to generate report');
      default:
        return of(undefined);
    }
  }

  private downloadReport(fileUrl: string): Observable<ReportStatusType> {
    return this.reportDownloadUseCaseService.execute(fileUrl).pipe(
      map(() => REPORT_STATUS_TYPE.GENERATED),
      catchError(error => {
        console.error('Error downloading report:', error);
        return of(REPORT_STATUS_TYPE.GENERATED);
      })
    );
  }
}
